import React from 'react';
import BillingAddressCardBody from './BillingAddressCardBody.jsx';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Wrapper = styled.div`
  .card-footer.active {
    background-color: #004753;
  }
  &.congress .card-footer {
    cursor: pointer;
    color: #439394;
  }
  &.congress .card-footer.active {
    color: #fff;
    background-color: #439394!important;
  }
`

const BillingAddressCard = (props) => {
  const {
    id,
    cardTitle,
    businessName,
    lastName,
    firstName,
    isDefault,
    address,
    postalCode,
    city,
    country,
    taxId,
    onDefineAsDefault,
    onDelete,
    col,
    context,
    connected_as,
    membres_id
  } = props;

  const { t: gctrad } = useTranslation();

  return (
    <Wrapper className=
      { context == "congress" ?
        "congress billing-address-card col-12 col-md-6 mb-4"
        :
        col == 12 ? 
          "billing-address-card col-12 mb-4"
          :
          "billing-address-card col-12 col-md-6 mb-4 " + (col == 2 ? "col-xl-6" : "col-xl-4")
      }
    >
      <div className="card h-100">
        <div className="card-header d-flex justify-content-between align-items-center">
            <h6 className="card-subtitle text-gc-dark-blue font-weight-bold m-0">{cardTitle}</h6>
            { context != 'readonly' &&
              <div>
                { context == "congress" ?
                  <a
                    className="m-0 btn btn-light btn-sm rounded-circle btn-edit-payment-infos"
                    data-toggle="modal"
                    data-target={"#modalEditPaymentsInfos" + id}
                  >
                    <i className="fas fa-edit text-gc-dark-blue"></i>
                  </a>
                :
                  <a 
                    href="#"
                    data-part="+"
                    data-target={connected_as + '//account/billing_address/edit/' + id + '/' + membres_id}  
                    className="m-0 btn btn-light btn-sm rounded-circle js-nav get_part_link"
                  >
                    <i className="fas fa-edit text-gc-dark-blue"></i>
                  </a>
                }
                {isDefault == 0 ?
                (
                  <button type="button" onClick={() => onDelete(id)} className="ml-1 m-0 btn btn-light btn-sm rounded-circle">
                    <i className="fas fa-trash text-gc-dark-blue"></i>
                  </button>
                ) : ('')}                        
              </div>
            }
        </div>

        <BillingAddressCardBody
          businessName={businessName}
          lastName={lastName}
          firstName={firstName}
          address={address}
          postalCode={postalCode}
          city={city}
          country={country}
          taxId={taxId}
        />

        {context != 'readonly' && 
          <>
            {isDefault == 1 ?
              <div className="card-footer font-weight-bold bg-dark-blue text-white active">
                <span><i className="fas fa-check mr-1"></i> {'adresse_par_defaut'.trad()}</span>
              </div>
              :
              <div onClick={() => onDefineAsDefault(id)} className="card-footer font-weight-bold text-gc-orange cursor-pointer">
                <a>{'definir_par_defaut'.trad()}</a>
              </div>
            }
          </>
        }
      </div>            
    </Wrapper>
  );
}

export default BillingAddressCard;